var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7925 8.54208C7.0525 10.7825 9.0825 12.6112 11.5588 13.7592L13.4837 12.0175C13.72 11.8038 14.07 11.7325 14.3763 11.8275C15.3562 12.1204 16.415 12.2788 17.5 12.2788C17.9812 12.2788 18.375 12.635 18.375 13.0704V15.8333C18.375 16.2688 17.9812 16.625 17.5 16.625C9.28375 16.625 2.625 10.6004 2.625 3.16667C2.625 2.73125 3.01875 2.375 3.5 2.375H6.5625C7.04375 2.375 7.4375 2.73125 7.4375 3.16667C7.4375 4.15625 7.6125 5.10625 7.93625 5.99292C8.0325 6.27 7.9625 6.57875 7.7175 6.80042L5.7925 8.54208Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b855a4d0ee2e8b700f436d1086e7ca6a.svg";
export { ForwardRef as ReactComponent };